module.exports = __webpack_public_path__ + "img/award-bg.968641e.png";